export default "__VITE_ASSET__0fe2b43b__"